import BaseLineChart from "../BaseLineChart";

const CbsaCancerGrowthChart = (data) => {
  const chartData = Object.keys(data.data || {})
    .map((year) => ({
      name: year,
      value: Number.isFinite(data.data[year]) ? data.data[year] : 0,
    }))
    .sort((a, b) => Number(a.name) - Number(b.name));

  return (
    <BaseLineChart
      data={chartData}
      tooltipFormatter={(value) => `${value}%`}
    />
  );
};

export default CbsaCancerGrowthChart;
